<template>
    <div class="index">
        <Top index="1" />
        <NavBar />
        <BannerCompany id="nav1" style="" />
        <!-- 废弃
        <ShequEdu />
        -->
        <QueryScore />
        <NewsActivity />
        <!-- <ApplySecNew />  废弃 -->
        <ShequCourse />
        <!-- 废弃 <CourseNotice /> -->
        <Expert />
        <Teacher />
        <!--  废弃 <ApplySec /> -->
        <ShequInstitu />
        <UnitSearch />
        
        <Bottom />
        
    </div>
</template>

<script>
// @ is an alias to /src
import Top from "@/views/index/Top.vue";
import NavBar from "@/views/index/NavBar.vue";
import BannerCompany from "@/views/index/BannerCompany.vue";
import ShequCourse from "@/views/index/ShequCourse.vue";
import QueryScore from "@/views/index/QueryScore.vue";
import CourseNotice from "@/views/index/CourseNotice.vue";
import Expert from "@/views/index/Expert.vue";
import Teacher from "@/views/index/Teacher.vue";
//import ApplySec from "@/views/index/ApplySec.vue";
//import ApplySecNew  from "@/views/index/ApplySecNew.vue";
import ShequInstitu from "@/views/index/ShequInstitu.vue";
import NewsActivity from "@/views/index/NewsActivity.vue";
import ShequEdu from "@/views/index/ShequEdu.vue";
import UnitSearch from "@/views/index/UnitSearch.vue";
import Bottom from "@/views/index/Bottom.vue";
import Vue from 'vue'
// 引入vue-amap
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
export default {
    name: "index",
    components: {
        Top,
        NavBar,
        BannerCompany,
        ShequCourse,
        QueryScore,
        CourseNotice,
        Expert,
        Teacher,
        //ApplySec,
        //ApplySecNew,
        ShequInstitu,
        NewsActivity,
        ShequEdu,
        UnitSearch,
        Bottom,
    },
    data(){
        return {

        }
    },
    methods:{
        //锚点跳转
        scrollIntoView(id){
            document.getElementById(id).scrollIntoView(true);
        },
      
    },
   
};
</script>   

<style lang="scss">
.body{margin:0;background-color:#f5f5f5;}
.content{max-width:1200px;margin-left: auto;  margin-right: auto;}
.sec{background-color:#fff;border:1px solid #eee;position:relative;}
.tab-head{min-height:50px;border-bottom:2px solid $theme-color;line-height:1.2;}
.tab-item{padding:10px 15px;height:100%;font-weight:600;font-size:16px;}
.sec-right-up{}
.look-more{color:$theme-color;font-size:12px;cursor:pointer;white-space: nowrap;padding-right:10px;}
.tabTitle{font-weight:600;font-size:16px;font-family:'思源黑体粗体';}
.tabTitle .title-icon{margin-right:5px;color:$theme-color;font-size:18px;}
.title-icon-img{margin-right:5px;height:24px;}
.nodata{color:#999;padding-top:15px;padding-bottom:25px;}

.sec-head-title-box{margin-bottom:20px;}
.sec-head-title{background:$theme-color;font-size:14px;color:#fff;border-radius:4px;padding:6px 10px;display:inline-block;position:relative;margin-bottom:20px;}
.sec-head-title-box .sec-head-title{margin-bottom:0;}
.sec-head-title:after{content:'';position:absolute;bottom:0;left:0;height:2px;background:$theme-color;width:1140px;}
</style>
